import { DocumentTypeModel } from "./DocumentType.model";

export class LegalRepresentativeModel {
    public CreatedBy: string;
    public CreatedDate: Date;
    public DocumentType: string;
    public DocumentNumber: string;
    public Email: string;
    public Id: number;
    public IdNationality: string;
    public NationalityName: string;
    public DocumentTypeName: string;
    public IdRequest: number;
    public ModifiedBy: string;
    public ModifiedDate: Date;
    public Name: string;
    public LastName: string;
    public DocumentTypeNavigation: DocumentTypeModel;
    public NameOld : string;
    public DocumentNumberOld : string;
    public EmailOld : string;
    public NationalityNameOld : string;
    public DocumentTypeNameOld : string;
    public BirthDate: Date;
    public AttachDocumentsCheckBoxResponse: boolean;
    public changeMotive: string;
}